// extracted by mini-css-extract-plugin
export var actionButton = "_l2-0";
export var actionMenuContainer = "_l2-i";
export var bubble = "_l2-2";
export var bubbleActionMenu = "_l2-j";
export var bubbleContext = "_l2-6";
export var bubbleItems = "_l2-7";
export var customer = "_l2-3";
export var divider = "_l2-8";
export var fileList = "_l2-9";
export var hiddenComment = "_l2-o";
export var infoAbove = "_l2-a";
export var internal = "_l2-4";
export var lightActionButton = "_l2-1";
export var link = "_l2-b";
export var merchant = "_l2-5";
export var message = "_l2-c";
export var profilePicture = "_l2-e";
export var quillToolbarContainer = "_l2-f";
export var senderDate = "_l2-g";
export var senderDateCustomer = "_l2-h";
export var senderName = "_l2-d";
export var time = "_l2-k";
export var uploadedImage = "_l2-l";
export var username = "_l2-m";
export var xsmall = "_l2-n";